<template>
  <div class="box">
    <el-form :model="info" label-position="right" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm" size="small">
      <el-form-item label="标题" prop="title">
        <el-input v-model="info.title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="充值金额" prop="amount">
        <el-input v-model="info.amount" placeholder="请输入金额"></el-input>
      </el-form-item>
      <el-form-item label="折扣" prop="discount">
        <el-input v-model="info.discount" placeholder="请输入折扣"></el-input>
      </el-form-item>
      <el-form-item label="权益说明" prop="intro">
        <wang-edit :txt="info.intro" :callback="setText"></wang-edit>
      </el-form-item>
      <el-form-item label="排序倒序" prop="ordering">
        <el-input v-model="info.ordering" placeholder="请输入排序"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button type="button" @click="reBack()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>

import WangEdit from "@/components/WangEdit";
export default {
  data() {
    return {
      info: {
        id: 0,
        title: '',
        amount: '',
        discount: '',
        intro: '',
      },
      img: [],
      source_domain: this.config.SOURCE_DOMAIN,
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
      }
    };
  },
  created() {
    if(this.$route.query.id) {
      this.info.id = this.$route.query.id
      this.getInfo()
    }
  },
  mounted() {
  },
  components: {
    WangEdit,
  },
  computed: {
  },
  methods: {
    setText(txt) {
      this.info.intro = txt
    },
    getInfo() {
      var that = this
      this.$api.member.memberGradeInfo({id: that.info.id}, function (res) {
        if(res.errcode == 0) {
          that.info = res.data
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    submitForm(formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var param = that.info
          this.$api.member.memberGradeEdit(param,function (res) {
            if(res.errcode == 0) {
              that.success(res.errmsg)
              that.reBack()
            } else {
              that.fail(res.errmsg)
            }
          })
        } else {
          return false;
        }
      });
    },
  }
};
</script>
<style scoped>
  .box {
    background-color: #fff;
    padding: 20px;
    border-radius: 6px;
    min-height: 500px;
  }
  .ruleForm {
    width: 800px;
  }
</style>
